import { Component, OnInit, Input } from '@angular/core'
import { TrainingStateGateway } from '../../gateways/training-state-gateway'
// import { TrainingModel } from '../../models/training-model'
import { Router } from '@angular/router'
@Component({
    templateUrl: 'user-training-details-component.html'
})
export class UserTrainingDetailsComponent implements OnInit {
    @Input() trainingheader: string
    userCoursesViewModel: any[]
     showDetails4 = false
     showDetails = false
     showDetails2 = false
     showDetails1 = false
     showDetails3 = false
     showDetails5 = false

    constructor(
        public trainingStateGateway: TrainingStateGateway,
        private router: Router
    ) {
    }
  toggleDetails(): void {
    this.showDetails = !this.showDetails
  }
  toggleDetails1(): void {
    this.showDetails1 = !this.showDetails1
  }
  toggleDetails2(): void {
    this.showDetails2 = !this.showDetails2
  }

  toggleDetails3(): void {
    this.showDetails3 = !this.showDetails3
  }
  toggleDetails4(): void {
    this.showDetails4 = !this.showDetails4
  }
  toggleDetails5(): void {
    this.showDetails5 = !this.showDetails5
  }
    ngOnInit(): void {
        this.trainingheader = 'Training'
  //     this.trainingStateGateway.GetUserTrainingDetails('2016', '14962', 'vpanda').subscribe(
         //   (model: TrainingModel[]) => {
           // this.userCoursesViewModel = model
        //    }
       // )
this.userCoursesViewModel = [
{CourseID: '2017_EZ1', CourseName: '2017 EZ Medicare Overview',
 LastAccess: 'Feb 27, 2017', CompletionDate: 'Feb 27, 2017', Status: 'Passed'},
{CourseID: '2017_EZ2', CourseName: '2017 EZ Medicare Compliance',
 LastAccess: 'Feb 27, 2017', CompletionDate: 'Feb 27, 2017', Status: 'Passed'}
]
    }
 btnOnlineTraining() {
        this.router.navigateByUrl('/user')
}
}
